import { useMemo } from 'react';

import { PayrunsTableType, PersonaRole } from '@xemplo/gp-types';
import { useRoleAuthorisation } from '@xemplo/roles-query';
import { usePayrunsType } from '@xemplo/use-payruns-type';

import { ColumnIds } from './payrun-base-table.types';
import { ColumnVisibility } from './payrun-base-table.types';

export const usePayrunColumnVisibility = () => {
  const { data: roleAuthData, isLoading, isInRole } = useRoleAuthorisation();
  const { payrunsType } = usePayrunsType();

  const columnVisibility = useMemo(() => {
    if (isLoading || !roleAuthData?.result?.roleName) {
      return {};
    }

    const shouldHideActionsForTab = payrunsType === PayrunsTableType.SystemGenerated;

    // Role-based visibility rules
    const isAdminRole = isInRole([
      PersonaRole.SystemAdmin,
      PersonaRole.PSPAdmin,
      PersonaRole.PayrollManager,
    ]);

    if (isAdminRole) {
      // Admin roles see Tags but not Company or AmendmentDueDate
      const adminVisibility = {
        [ColumnIds.Company]: false,
        [ColumnIds.AmendmentDueDateTimeUtc]: false,
      };
      return shouldHideActionsForTab
        ? { ...adminVisibility, [ColumnIds.Actions]: false }
        : adminVisibility;
    }

    // Non-admin roles hide specific columns
    return {
      [ColumnIds.Company]: false,
      [ColumnIds.BusinessUnitName]: false,
      [ColumnIds.AmendmentDueDateTimeUtc]: false,
      [ColumnIds.Assignee]: false,
      [ColumnIds.Tags]: false,
      [ColumnIds.Actions]: false, // Always hidden for non-admin roles
    };
  }, [isLoading, roleAuthData?.result?.roleName, payrunsType, isInRole]);

  return columnVisibility as Partial<ColumnVisibility>;
};
